const EVENTS = new Set(['enabled', 'focus', 'blur', 'visibilitychange', 'pageshow', 'pagehide', 'pointerdown', 'pointerup', 'pointercancel', 'gotpointercapture', 'lostpointercapture', 'focusin', 'focusout', 'route', 'request', 'response', 'error', 'render', 'resize', 'window-focus', 'element-focus', 'window-open'])
const SOURCES = new Set(['window', 'document', 'router', 'http', 'timeline', 'map'])

/** 手动启用的内存环形记录；不采集 URL、请求正文、目标文本或认证字段。 */
export function createWindowDiagnostics({ win = window, doc = document, routeName = () => '', limit = 2000 } = {}) {
  let enabled = false
  const events = []; const cleanup = []
  const record = (event, source = 'window') => {
    if (!enabled || !EVENTS.has(event) || !SOURCES.has(source)) return
    events.push({ time: new Date().toISOString(), event, source, route: String(routeName() || '').slice(0, 80), visibility: doc.visibilityState, focused: doc.hasFocus() })
    if (events.length > limit) events.splice(0, events.length - limit)
  }
  const listen = (target, type, source) => {
    const handler = () => record(type, source)
    target.addEventListener(type, handler, true)
    cleanup.push(() => target.removeEventListener(type, handler, true))
  }
  const observeCall = (target, key, event) => {
    if (typeof target?.[key] !== 'function') return
    const original = target[key]
    const wrapped = function (...args) { record(event); return original.apply(this, args) }
    target[key] = wrapped
    cleanup.push(() => { if (target[key] === wrapped) target[key] = original })
  }
  return {
    record,
    enable() {
      if (enabled) return
      enabled = true; events.length = 0
      for (const type of ['focus', 'blur', 'pageshow', 'pagehide']) listen(win, type, 'window')
      for (const type of ['visibilitychange', 'pointerdown', 'pointerup', 'pointercancel', 'gotpointercapture', 'lostpointercapture', 'focusin', 'focusout']) listen(doc, type, 'document')
      observeCall(win, 'focus', 'window-focus'); observeCall(win, 'open', 'window-open')
      observeCall(win.HTMLElement?.prototype, 'focus', 'element-focus')
      record('enabled')
    },
    disable() { enabled = false; cleanup.splice(0).reverse().forEach(remove => remove()) },
    snapshot() { return { enabled, browser: win.navigator?.userAgent || '', events: events.map(event => ({ ...event })) } }
  }
}

export function installWindowDiagnostics(router, request, win = window, doc = document) {
  const diagnostics = createWindowDiagnostics({ win, doc, routeName: () => router.currentRoute.value.name })
  const removeRoute = router.afterEach(() => diagnostics.record('route', 'router'))
  const outgoing = request.interceptors.request.use(config => { diagnostics.record('request', 'http'); return config })
  const incoming = request.interceptors.response.use(response => { diagnostics.record('response', 'http'); return response }, error => { diagnostics.record('error', 'http'); return Promise.reject(error) })
  win.microquakeWindowDiagnostics = diagnostics
  return () => {
    diagnostics.disable(); removeRoute()
    request.interceptors.request.eject(outgoing); request.interceptors.response.eject(incoming)
    if (win.microquakeWindowDiagnostics === diagnostics) delete win.microquakeWindowDiagnostics
  }
}
